"use client";

/* 
    Catalog Category component is used to show the books by category on catalog site
    This component accepts following proptypes.
    @param props - data returned by the API, page slug, page number and sitesetting
*/

import React from 'react';
import { usePathname } from 'next/navigation';
import Pagination from '../Pagination/Pagination';
import Meta from '../Meta';
import Entity from '../Entity';
import {
    getPageNumberAsInt,
    _isFirstPage,
    _isLastPage,
    previousLink,
    nextLink,
    getBasePageLink,
    getLastPageNumber,
    getPaginationText,
    startCase
} from '../../helpers/Helper';
import PropTypes from 'prop-types';
import { useAppContext } from '@components/Provider';
import styles from "./CatelogCategory.module.css";
import CatalogBookCard from '@components/CatalogBookCard/CatalogBookCard';


const populateSEO = (title) => {
    let SEO_Data = {
        Title: startCase(`${title}`),
        Description: "Browse and get to know Open Road's celebrated authors; access and purchase 10,000 ebooks from over 2000 author",
    };
    return SEO_Data;
};
const CatalogCategory = (props) => {
    props = props.categoryData;
    const pathname = usePathname();
    const context = useAppContext();
    if (!context) {
        console.error("CatalogCaetgory: Invalid context:", context);
        console.error("CatalogCaetgory: pathname :", pathname);
        throw error; // Or handle gracefully
    }    
    
    let { data, host, siteId, router, isMobile, subscriberCookie } = context || {},
    [catalogBooks] = props && Array.isArray(props?.data) && props.data || [],
    { books } = catalogBooks && catalogBooks.Category || {},
    totalBooks = catalogBooks && catalogBooks.Category && catalogBooks.Category.total || 0,
    { SiteSettings } = data || {},
    siteName = SiteSettings.site_name,
    slugName = props.slug ? decodeURIComponent(props.slug) : '',
    pageSize = props.pageSize,
    currentPageNumber = getPageNumberAsInt(props.pageNumber),
    isFirstPage = _isFirstPage(currentPageNumber),
    isLastPage = _isLastPage(currentPageNumber, totalBooks, pageSize);
    //router return the dynamic path
    const route = router.pathname ? router.pathname : router.asPath;
    return (
        <React.Fragment>
            <Meta
                url={props.pageUrl}
                static={populateSEO(`${slugName} | ${siteName}`)}
                pageType={Entity.STATIC}
                siteName={siteName}
                domain={host}
                isFirstPage={isFirstPage}
                isLastPage={isLastPage}
                previousLink={previousLink(props.pageName, slugName, currentPageNumber)}
                nextLink={nextLink(props.pageName, slugName, currentPageNumber)}
                isNewAppRouter={true}
            />
            <div className={isMobile ? 
                [styles.CatelogCategorySection, styles.bookCardContainer, "bookCardContainer", subscriberCookie ? styles.topPaddingCookie : styles.topPaddingNoCookie, "topPadding"].join(" ") :
                [styles.CatelogCategorySection, styles.bookCardContainer, "bookCardContainer"].join(" ")}
                >
                <h1>{startCase(decodeURIComponent(slugName))} ({totalBooks > 1 ? `${totalBooks} Books` : `${totalBooks} Book`})</h1>
                <div className="booksCard">
                    <CatalogBookCard
                        Books={books}
                        AffiliateCode={SiteSettings.preview_link_affiliate_code}
                        SiteId={siteId}
                        host={host}
                        ShowContributor={true}
                        TotalBooks={totalBooks}
                        RenderSchema={true}
                        ShowFollowAuthor={false}
                        EventName="clickFollow-CategoryPage"
                        ShouldLazyLoadCount={8}
                        subscriberCookie={subscriberCookie}
                    />
                </div>
                <Pagination
                    isFirstPage={isFirstPage}
                    isLastPage={isLastPage}
                    basePageLink={getBasePageLink(props.pageName, slugName)}
                    currentPageNumber={currentPageNumber}
                    lastPageNumber={getLastPageNumber(totalBooks, pageSize)}
                    getLinkHref={route}
                    paginationText={getPaginationText(totalBooks, currentPageNumber, pageSize, 'eBooks')}
                    pageSize={pageSize}
                />
            </div>
        </React.Fragment>
    )
}

CatalogCategory.propTypes = {
    props: PropTypes.object,
}

export default CatalogCategory;